import React from 'react';
import {useTranslation} from 'react-i18next';

import {IconExternalLink, IconHelp} from '@veneer/core';

import {A, ButtonLink} from '@br/mg-components';

import useStyles from './styles';

const KBLink = ({href, label}: {href: string; label?: string}) => {
    const {t} = useTranslation(['KBLink']);
    const styles = useStyles();

    if (label) {
        return (
            <p className={styles.withLabel}>
                <IconHelp />
                <A
                    target="_blank"
                    href={href}
                    rel="noopener noreferrer"
                >
                    <span>{label}</span>
                    <IconExternalLink
                        aria-label=""
                        aria-hidden
                        size={16}
                    />
                </A>
            </p>
        );
    }

    const helpString = t('KBLink:help', 'Help');

    return (
        <ButtonLink
            href={href}
            appearance="ghost"
            target="_blank"
            small
            ariaLabel={helpString}
            leadingIcon={<IconHelp aria-label={helpString} />}
        />
    );
};

export default KBLink;
